import { resolveExternalHttpUrl } from '@/feature/externalNavigation/externalNavigationGuard'

export const extractActualUrl = (urlString: string): string => {
  return resolveExternalHttpUrl(urlString) ?? ''
}
